<script>
import { mapActions, mapGetters } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import ListagemGenerica from '@/components(new)/UI/Tables/ListagemGenerica/ListagemGenerica.vue'
import FiltroGenerico from '@/components(new)/UI/Filters/FiltroGenerico/FiltroGenerico.vue'
import BaseTable from '@/components(new)/UI/Tables/BaseTable/BaseTable.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import EMPTY_FILTRO_PROCESSO from '@/libs/models/filtro/emptyFiltroProcesso'
import PermissaoHelper from '@/utils/PermissaoHelper.vue'
import AppModalVisualizarCadastro from '@/components(new)/UI/Modals/VisualizacaoCadastro/AppModalVisualizarCadastro.vue'
import TrocarResponsavel from '@/components(new)/UI/Modals/TrocarResponsavel/TrocarResponsavel.vue'

export default {
  mixins: [
    AppNotificacao,
    PermissaoHelper
  ],
  components: {
    ListagemGenerica,
    FiltroGenerico,
    BaseTable,
    InputSelect,
    AppModalVisualizarCadastro,
    TrocarResponsavel
  },
  data () {
    return {
      filtro: EMPTY_FILTRO_PROCESSO('CAIXA_EM_CERTIFICACAO'),
      totalElements: 0,
      totalPages: 0,
      processos: [],
      municipios: [],
      orgaos: [],
      responsaveis: [],
      sps: [],
      modalVisualizarCadastroIsOpen: false,
      protocolo: null,
      modalTrocarResponsavelIsOpen: false,
      idProcesso: null
    }
  },
  mounted () {
    this.loadLista()
    this.getMunicipios()
    this.getOrgaos()
    this.getResponsaveis()
  },
  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    })
  },
  methods: {
    ...mapActions({
      findByFilter: 'processo/findByFilter',
      findAllOrgaos: 'pessoa/findAllOrgaos',
      findMunicipiosBySetorLogado: 'municipios/findMunicipiosBySetorLogado',
      findResponsaveisBySetorLogado: 'usuario/findResponsaveisBySetorLogado',
      trocarResponsavel: 'processo/trocarResponsavel'
    }),
    async loadLista () {
      const response = await this.findByFilter(this.filtro)
      this.processos = this.formatarDadosTabela(response.content)
      this.totalElements = response.totalElements
      this.totalPages = response.totalPages
    },
    formatarDadosTabela (dados) {
      return dados.map(dado => ({
        ...dado,
        actions: [
          { key: 'analyze-process', label: 'Continuar emissão do certificado', iconPrefix: 'far', icon: 'file-alt', show: this.usuario.id === dado.idResponsavel, action: () => this.continuarEmissaoCertificado(dado.id) },
          { key: 'view-process', label: 'Visualizar processo', iconPrefix: 'far', icon: 'eye', action: () => this.viewCadastro(dado.numeroProtocolo) },
          { key: 'change-responsible', label: (!dado.nomeResponsavel ? 'Vincular processo' : 'Trocar responsável'), iconPrefix: 'fal', icon: 'users', action: () => this.openModalTrocarResponsavel(dado.id), show: this.isChefeSetor() }
        ]
      }))
    },
    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.loadLista()
    },
    pesquisar (pesquisaSimples) {
      this.filtro.campoSimples = pesquisaSimples
      this.filtro.pagina = 0
      this.loadLista()
    },
    limparPesquisa () {
      this.filtro = EMPTY_FILTRO_PROCESSO('CAIXA_EM_CERTIFICACAO')
      this.loadLista()
    },
    async getMunicipios () {
      const municipios = await this.findMunicipiosBySetorLogado()
      this.municipios = municipios.map(municipio => ({id: municipio.id, nome: municipio.nome}))
    },
    async getOrgaos () {
      const orgaos = await this.findAllOrgaos()
      this.orgaos = orgaos.map(orgao => ({id: orgao, nome: orgao}))
    },
    async getResponsaveis () {
      const responsaveis = await this.findResponsaveisBySetorLogado()
      this.responsaveis = responsaveis.map(responsavel => ({id: responsavel.id, nome: `${responsavel.nomeRazaoSocial} (${responsavel.perfil.nome})`}))
    },
    async alterarResponsavel (idProcesso, idUsuario) {
      await this.trocarResponsavel({id: idProcesso, idUsuario})
      this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Responsável alterado com sucesso.')
      this.limparPesquisa()
    },
    viewCadastro (protocolo) {
      this.protocolo = protocolo
      this.modalVisualizarCadastroIsOpen = true
    },
    closeModalVisualizarCadastro () {
      this.modalVisualizarCadastroIsOpen = false
      this.protocolo = null
    },
    openModalTrocarResponsavel (idProcesso) {
      this.modalTrocarResponsavelIsOpen = true
      this.idProcesso = idProcesso
    },
    closeModalTrocarResponsavel () {
      this.modalTrocarResponsavelIsOpen = false
      this.idProcesso = null
    },
    async handleAlterarResponsavelModal (idResponsavel) {
      await this.alterarResponsavel(this.idProcesso, idResponsavel)
      this.closeModalTrocarResponsavel()
    },
    async continuarEmissaoCertificado (idProcesso) {
      this.$router.push({
        name: 'certificacao/emitir',
        params: {
          id: idProcesso
        }
      })
    }
  }
}
</script>

<template>
  <div class="container">
    <AppModalVisualizarCadastro
      v-if="modalVisualizarCadastroIsOpen"
      :protocolo="protocolo"
      @closeModal="closeModalVisualizarCadastro"
    />
    <TrocarResponsavel
      v-if="modalTrocarResponsavelIsOpen"
      @closeModal="closeModalTrocarResponsavel"
      @alterar="handleAlterarResponsavelModal"
    />
    <div class="content-cadastro">
      <div class="flex-start mt-3 mb-3">
        <FiltroGenerico
          placeholder="Pesquisar por número de processo, nome do proprietário ou CPF/CNPJ"
          widthInput="85%"
          @filtrosPesquisa="pesquisar"
          @limpar="limparPesquisa"
        >
          <template #filtros>
            <InputSelect
              label="Municípios:" v-model="filtro.municipios"
              :multiSelect="true"
              :opcoes="municipios"
            />
            <InputSelect
              label="Tipo de SPS:" v-model="filtro.sps"
              :multiSelect="true"
              :opcoes="sps"
            />
            <InputSelect
              label="Órgão:" v-model="filtro.orgao"
              :opcoes="orgaos"
            />
            <InputSelect
              label="Responsável:" v-model="filtro.responsavel"
              :opcoes="responsaveis"
            />
          </template>
        </FiltroGenerico>
      </div>
      <BaseTable
        title="Listagem"
        :tableData="processos"
        :columns="[
          { key: 'numeroProcesso', label: 'N° Processo', width: '150rem' },
          { key: 'cpfCnpjProprietario', label: 'CPF/CNPJ', width: '150rem'},
          { key: 'nomeRazaoSocialProprietario', label: 'Proprietário/Razão social' },
          { key: 'status.nome', label: 'Status', align: 'center' },
          { key: 'municipio', label: 'Município' },
          { key: 'sps', label: 'SPS' },
          { key: 'nomeResponsavel', label: 'Responsável' },
          { key: 'orgao', label: 'Órgão' },
          { key: 'actions', label: 'Ações', align: 'center' }
        ]"
        :pagination="{
          show: true,
          pageSize: filtro.tamanhoPagina,
          totalPages: totalPages,
          totalElements: totalElements
        }"
        @pageChange="changePage"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/analise/certificacao/caixa-em-certificacao/caixa-em-certificacao.vue